import React,{ useState } from "react";
import { Box } from '@mui/material';

import GeoLocation from './GeoLocation'
import { CustomLoadingOverlay, GenericDialog, GeoLocationGeneric } from './'
import { useTranslation } from "react-i18next";

export function LocationDialogComponent(props) {
  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");
  const {t} = useTranslation()

  return (<GenericDialog open={props.open} onClose={props.closeAction}
    title={t("geolocalization_title")}
    content={<Box sx={{
      display: 'flex',
      position: 'relative',
      height: '80vh',
    }}>
       <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
        console.log("succes,latitude, longitude ", latitude, longitude);
        setLat(latitude);
        setLon(longitude);
      }}
        ErrorFN={(error) => console.log('error', error)}
      />  
        <GeoLocation
          center={{ lat: parseFloat(lat), lng: parseFloat(lon) }}
          zoom={17}
        /> 
    </Box>}
  />);
}
